import AccessibilityHelper from '../lib/AccessibilityHelper.js';

export default {
    name: 'filtersservice',
    dependencies: [],
    callable() {
        const ele = document.querySelector('[data-filters-overlay]');
        if (!ele) {
            return;
        } // FIXME: don't event initialize if not necessary
        const showButtonEle = document.querySelector(
            '[data-show-filters-button]'
        );

        // Initial state
        const active = new URL(document.baseURI).searchParams.has('filters');
        window.history.replaceState({ 'filters-active': active }, null);

        toggle(active);

        window.addEventListener('popstate', event => {
            // E.g. Chrome pre-34 fires popstate on load
            if (!window.history.state) {
                return;
            }

            if (!event.state) {
                return;
            }

            const active = event.state['filters-active'];
            if (active !== undefined) {
                toggle(Boolean(active));
            }
        });

        function toggle(active) {
            if (active) {
                showFilters();
            } else {
                hideFilters();
            }
        }

        function show() {
            showFilters();
            window.setTimeout(() => {
                const url = new URL(document.baseURI);
                url.searchParams.set('filters', '');
                window.history.pushState({ 'filters-active': true }, null, url);
                AccessibilityHelper.focusFirst(ele);
            }, 300); // as long as the transition time for the modal overlay element.
        }

        function hide() {
            hideFilters();
            window.setTimeout(() => {
                const url = new URL(document.baseURI);
                url.searchParams.delete('filters');
                window.history.pushState(
                    { 'filters-active': false },
                    null,
                    url
                );
                showButtonEle.focus();
            }, 300); // after the animation
        }

        function showFilters() {
            ele.style.webkitTransform = 'translate3d(0, 0, 0)';
            ele.style.transform = 'translate3d(0, 0, 0)';
            ele.removeAttribute('aria-hidden');
        }

        function hideFilters() {
            ele.style.removeProperty('-webkit-transform');
            ele.style.removeProperty('transform');
            ele.setAttribute('aria-hidden', 'true');
        }

        return {
            show,
            hide,
        };
    },
};



// WEBPACK FOOTER //
// ./services/filtersservice.js